import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lazyload",
  "data-script": "https://accounts.google.com/gsi/client"
}
const _hoisted_2 = ["data-script"]
const _hoisted_3 = ["data-script"]

import {
  getAppInfo,
} from 'utilities';
import {
  onMounted,
  ref,
} from 'vue';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyScript',
  setup(__props) {


const authStore = useStore.auth;
const backendStore = useStore.backend;

const shouldPrefetch = ref(false);

onMounted(() => {
  setTimeout(() => {
    shouldPrefetch.value = true;
  }, 5 * 1000);
});

function getWebpackChunk(chunk: string): string {
  const {
    IS_DEVELOPMENT,
    CONFIG,
  } = getAppInfo();

  const hasPublicPath = !!CONFIG.clientPublicPath.trim();
  const origin = hasPublicPath ? CONFIG.clientPublicPath.trim() : window.location.origin;

  // NOTE: defined in `vue.config.js`
  const chunkHash = process.env.CHUNK_HASH;
  const chunkPostfix = IS_DEVELOPMENT ? '' : `.${chunkHash}`;

  return `${origin}/js/${chunk}${chunkPostfix}.js`;
}

const commonWebpackChunks = [
  'home',
  'free-courses',
  'dynamic-pages',
  'course-details',

  'privacy-policy',
  'refund-policy',
  'terms-of-service',
  'faq',
  'about-us',
  'news',
];

const loggedWebpackChunks = [
  'user-utilities-view',
  'user-dashboard-view',

  'user-enrolled-courses',
  'user-running-courses',
  'user-upcoming-courses',

  'course-materials',
  'user-exam',
  'user-result',
  'leader-board',
  'user-account-view',

  ...commonWebpackChunks,
];

const nonLoggedWebpackChunks = [
  'our-courses',

  'auth',

  ...commonWebpackChunks,
];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(backendStore).clientCompany.utilitiesSettings.googleAuth2ClientId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (shouldPrefetch.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(authStore).user)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(loggedWebpackChunks, (chunk) => {
                return _createElementVNode("div", {
                  key: chunk,
                  class: "lazyload",
                  "data-script": getWebpackChunk(chunk)
                }, null, 8, _hoisted_2)
              }), 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(nonLoggedWebpackChunks, (chunk) => {
                return _createElementVNode("div", {
                  key: chunk,
                  class: "lazyload",
                  "data-script": getWebpackChunk(chunk)
                }, null, 8, _hoisted_3)
              }), 64))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})